var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFolder24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.5C20.1607 9.5 20.3117 9.57726 20.4056 9.70765C20.4996 9.83804 20.5252 10.0057 20.4743 10.1581L18.0353 17.4744C17.8311 18.0869 17.2579 18.5 16.6123 18.5H5C4.17157 18.5 3.5 17.8284 3.5 17V7C3.5 6.17157 4.17157 5.5 5 5.5H8C8.13261 5.5 8.25979 5.55268 8.35355 5.64645L9.54044 6.83333H18C18.2761 6.83333 18.5 7.05719 18.5 7.33333V9.5H20ZM4.5 7C4.5 6.72386 4.72386 6.5 5 6.5H7.79289L8.97978 7.68689C9.07355 7.78065 9.20073 7.83333 9.33333 7.83333H17.5V9.5H7.32902C6.6794 9.5 6.1036 9.91817 5.90262 10.5359L4.5 14.8471V7ZM4.71701 17.4123C4.79748 17.4676 4.89496 17.5 5 17.5H16.6123C16.8275 17.5 17.0185 17.3623 17.0866 17.1581L19.3063 10.5H7.32902C7.11248 10.5 6.92055 10.6394 6.85356 10.8453L4.71701 17.4123Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder24);
export default __webpack_public_path__ + "static/media/icon-folder-24.aaf7baba.svg";
export { ForwardRef as ReactComponent };